import { Trans, useLingui } from '@lingui/react'
import { bool, func, string } from 'prop-types'
import { useState } from 'react'

import noop from 'shared/utils/noop'
import Button from 'views/components/atoms/Button'
import Form from 'views/components/atoms/Form'
import FormControlWithFloatingLabel from 'views/components/molecules/FormControlWithFloatingLabel'
import Modal from 'views/components/molecules/Modal'

import './PrescriptionPhoneNumberModal.scss'

const PrescriptionPhoneNumberModal = ({
  handlePhoneNumberChange,
  id,
  open,
  // i18n,
}) => {
  const [phoneNumber, setPhoneNumber] = useState('')

  const { i18n } = useLingui()

  const changeNumber = event => {
    setPhoneNumber(event.target.value)
  }

  return (
    <Modal
      title={i18n._('checkout.prescription.phoneNumber.modal.title')}
      id={id}
      size="medium"
      open={open}
      isClientSideControlled
    >
      <p>
        <Trans id="checkout.prescription.phoneNumber.modal.information" />
      </p>
      <Form name="prescription-form">
        <div className="o-PrescriptionPhoneNumberModal--buttons l-flex l-flex--start o-wrap">
          <div className="o-PrescriptionPhoneNumberModal--buttons__flexOne">
            <FormControlWithFloatingLabel
              required
              name="PrescriptionForm-telephone"
              inputType="tel"
              onChange={changeNumber}
            >
              <Trans id="general.form.label.phone" />
            </FormControlWithFloatingLabel>
          </div>
          <div className="o-PrescriptionPhoneNumberModal--buttons__flexOne">
            <Button
              name="submit-button"
              onClick={handlePhoneNumberChange(phoneNumber)}
            >
              <Trans id="general.form.label.phone.confirm" />
            </Button>
          </div>
        </div>
      </Form>
    </Modal>
  )
}

PrescriptionPhoneNumberModal.propTypes = {
  handlePhoneNumberChange: func,
  id: string.isRequired,
  open: bool,
  // i18n: shape({}).isRequired,
}

PrescriptionPhoneNumberModal.defaultProps = {
  handlePhoneNumberChange: noop,
  open: false,
}

export default PrescriptionPhoneNumberModal
